
import config from "@/client/config";
import FilterYear from "@/components/common/filter-year/filter-year.vue";
import loading from "@/components/common/loading/loading.vue";
import AlertGuidelineModal from "@/components/common/modal/alert-guideline-modal/alert-guideline-modal.vue";
import { Collection } from "@/models/collection";
import PeriodManagement from "@/models/period-management";
import Proposal from "@/models/proposal";
import { PageAccessLogService } from "@/services/page-access-log.service";
import { ProposalData } from "@/store/modules/proposal.store";
import ParticipantTemplate from "@/templates/participant/participant.template";
import { combineLatest } from "rxjs";
import { tap } from "rxjs/operators";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    FilterYear,
    loading,
    AlertGuidelineModal,
  },
})
export default class ParticipantIndex extends Vue {
  public periodManagements: PeriodManagement[] = [];
  public countDown = "";

  fields = [
    { key: "projectCode", thStyle: { width: "10%" } },
    { key: "projectYear", thStyle: { width: "10%" } },
    { key: "teamName", thStyle: { width: "15%" } },
    { key: "proposalTitle", label: "Project Title", thStyle: { width: "30%" } },
    { key: "kpi", thStyle: { width: "5%" }},
    { key: "status", thStyle: { width: "5%" } },
    { key: "leader", thStyle: { width: "20%" } },
    // { key: "roles", formatter: (value: string[]): string => value.join(", "), thStyle: { width: "5%" } },
    { key: "action", thStyle: { width: "5%" } },
  ];
  private load: {
    checkAllow: boolean;
    proposal: boolean;
    periodManagement: boolean;
  } = { checkAllow: false, proposal: false, periodManagement: false };

  public get currentPeriod(): number {
    return this.$store.state.PeriodManagementStore.currentPeriod;
  }

  public getPeriodManagements(): void {
    console.log(this.$store.state.PeriodManagementStore.periodManagements);
    this.periodManagements =
      this.$store.state.PeriodManagementStore.periodManagements;
  }

  public get phases(): string[] {
    return this.$store.state.Common.phases;
  }

  public get isAllowToSubmit(): any {
    return (this.$store.state.ProposalStore as ProposalData).isAllowToSubmit;
  }

  public get proposals(): Array<Collection<Proposal>> {
    return this.$store.state.ProposalStore.proposals;
  }

  public get subordinateProposals(): Array<Collection<Proposal>> {
    return this.$store.state.ProposalStore.subordinateProposals;
  }

  public get parent(): ParticipantTemplate {
    return this.$parent as ParticipantTemplate;
  }

  public async mounted(): Promise<void> {
    if (!(await this.isUserAccessedGuideline())) {
      this.$bvModal.show("alert-guideline-modal");
    }
    this.getPeriodManagementsByYear();
    this.getProposals();
    this.getSubordinateProposals();
    this.checkAllowToSubmit();
    this.countingDown();
  }

  public countingDown(): void {
    const intervalCountDown = setInterval(() => {
      if (
        this.periodManagements.length === 0 ||
        this.periodManagements[this.currentPeriod] === undefined
      ) {
        return;
      }
      if ([1, 3, 4].indexOf(this.currentPeriod) > -1) {
        clearInterval(intervalCountDown);
        return;
      }
      const duration = this.$moment.duration(
        Date.parse(this.periodManagements[this.currentPeriod].endAt) -
          Date.now()
      );
      if (duration.seconds() < 0) {
        this.countDown = "";
        clearInterval(intervalCountDown);
        return;
      }
      this.countDown = `${
        duration.days() > 0
          ? duration.days() + " day" + (duration.days() > 1 ? "s" : "") + " "
          : ""
      }${duration.hours().toString().padStart(2, "0")}:${duration
        .minutes()
        .toString()
        .padStart(2, "0")}:${duration.seconds().toString().padStart(2, "0")}`;
    }, 1000);
  }

  public async getData(): Promise<void> {
    const year = this.$store.state.Common.currentYear;
    const data = await Promise.all([
      this.$store.dispatch("ProposalStore/checkAllowToSubmit"),
      this.$store.dispatch("ProposalStore/getParticipantProposals"),
      this.$store.dispatch("ProposalStore/getSubordinateProposals"),
      this.$store.dispatch("PeriodManagementStore/getPeriodManagementsByYear", {
        year,
      }),
    ]);
    combineLatest(data)
      .pipe(
        tap(() => {
          this.getPeriodManagements();
          this.parent.pageLoading = false;
        })
      )
      .subscribe();
  }

  public checkLoading(): void {
    if (
      this.load.checkAllow &&
      this.load.periodManagement &&
      this.load.proposal
    ) {
      this.parent.pageLoading = false;
    } else if (this.parent.pageLoading === false) {
      this.parent.pageLoading = true;
    }
  }

  public checkAllowToSubmit(): void {
    this.load.checkAllow = false;
    this.parent.pageLoading = true;
    this.$store.dispatch("ProposalStore/checkAllowToSubmit").then((res) =>
      res
        .pipe(
          tap(() => {
            this.load.checkAllow = true;
            this.checkLoading();
          })
        )
        .subscribe()
    );
  }

  public getProposals(): void {
    this.load.proposal = false;
    this.parent.pageLoading = true;
    this.$store.dispatch("ProposalStore/getParticipantProposals").then((res) =>
      res
        .pipe(
          tap(() => {
            this.load.proposal = true;
            this.checkLoading();
          })
        )
        .subscribe()
    );
  }

  public getSubordinateProposals(): void {
    // this.load.proposal = false;
    // this.parent.pageLoading = true;
    this.$store.dispatch("ProposalStore/getSubordinateProposals").then((res) =>
      res
        .pipe(
          tap(() => {
            // this.load.proposal = true;
            // this.checkLoading();
          })
        )
        .subscribe()
    );
  }

  public getPeriodManagementsByYear(): void {
    this.load.periodManagement = false;
    this.parent.pageLoading = true;
    const year = this.$store.state.Common.currentYear;
    this.$store
      .dispatch("PeriodManagementStore/getPeriodManagementsByYear", { year })
      .then((res) =>
        res
          .pipe(
            tap(() => {
              this.getPeriodManagements();
              this.load.periodManagement = true;
              this.checkLoading();
            })
          )
          .subscribe()
      );
  }

  public isUserAccessedGuideline(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      PageAccessLogService.getPageAccessLog("guideline").subscribe({
        next: (result) => resolve(result),
        error: (err) => reject(err),
      });
    });
  }

  public isLock: boolean = config.disableSomeComponents;

  public formatKpi(kpi: number) {
    if (kpi === null || kpi === undefined || isNaN(kpi)) {
      return '0.0'
    }

    return Number(kpi).toFixed(1)
  }
}
